import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "📷", key: "proQuality" },
  { emoji: "💎", key: "uniqueToMe" },
  { emoji: "⚡", key: "speedAndEase" },
  { emoji: "🌟", key: "allAbove" },
]

export default function PetsSuccessSignalPage() {
  return (
    <RadioCardListPage translationKey="petsSuccessSignal" options={OPTIONS} />
  )
}
